/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Erp_File_InvalidInputs */

const en_error_erp_file_invalid = /** @type {(inputs: Error_Erp_File_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The outcome names rows this file does not have, or a row twice.`)
};

/**
* | output |
* | --- |
* | "The outcome names rows this file does not have, or a row twice." |
*
* @param {Error_Erp_File_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_erp_file_invalid = /** @type {((inputs?: Error_Erp_File_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Erp_File_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_erp_file_invalid(inputs)
});